import GridTile from "../grid/GridTile";
import LayerDescription from "../grid/LayerDescription";

/**
 * @interface
 */
export default class TerrainLayer {

    /**
     * @abstract
     * @returns {LayerDescription}
     */
    getLayerDescription() {}

    /**
     * @abstract
     * @param {number} minGridTileDepth
     * @param {number} maxGridTileDepth
     * @returns {boolean}
     */
    isLayerForGrid(minGridTileDepth, maxGridTileDepth) {}

    /**
     * @abstract
     * @param {GridTile} tile The tile
     * @param {number} tileDepth The depth of the tile in tile rows.
     * @returns {boolean}
     */
    isLayerForTile(tile, tileDepth) {}

    /**
     * @abstract
     * @returns {boolean} True if the terrain layer has ore tiles
     */
    isOreTileSupported() {}

    /**
     * @abstract
     * @returns {boolean} True if the terrain layer has gold tiles
     */
    isGoldTileSupported() {}

    /**
     * @abstract
     * @returns {boolean} True if the terrain layer has ruby tiles
     */
    isRubyTileSupported() {}

    /**
     * @abstract
     * @returns {boolean} True if the terrain layer has rare tiles
     */
    isUpgradeTileSupported() {}

    /**
     * @abstract
     * @param {GridTile} tile 
     */
    assignTileToOreType(tile) {}
    /**
     * @abstract
     * @param {GridTile} tile 
     */
    assignTileToGoldType(tile) {}
    /**
     * @abstract
     * @param {GridTile} tile 
     */
    assignTileToUpgradeType(tile) {}
    /**
     * @abstract
     * @param {GridTile} tile 
     */
    assignTileToRubyType(tile) {}

    /**
     * @abstract
     * @param {GridTile} tile 
     * @param {boolean} open
     */
    assignTileTerrain(tile, open) {}

}